import React from 'react';
import { Checkbox, FormControlLabel, Theme, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useI18n } from '../../../lib/hook/useI18n';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    alignItems: 'flex-start',
    '& .MuiCheckbox-root': {
      paddingTop: theme.spacing(0.25),
    },
  },
}));

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const UnifiedActivityDataConsentCheckbox: React.FC<Props> = (props: Props) => {
  const { checked, onChange } = props;
  const classes = useStyles();
  const { i18nClasses, t } = useI18n();

  return (
    <FormControlLabel
      classes={{ root: classes.root }}
      control={
        <Checkbox
          checked={checked}
          color="secondary"
          onChange={(e) => {
            onChange(e.target.checked);
          }}
        />
      }
      label={
        <Typography
          className={i18nClasses.root}
          color="textSecondary"
          component="span"
          variant="body2"
        >
          {t('room.welcome.modal.unified.activity_data_consent')}
        </Typography>
      }
    />
  );
};

export default UnifiedActivityDataConsentCheckbox;
